export default __webpack_public_path__ + "static/media/instagram.d27c75b4.png";